import React from "react";
import ReceptionistLayout from "../../Layouts/Receptionist/ReceptionistLayout";

export default function ReceptionistReports() {

    const summaryCards = [
        { title: "Total Appointments", value: 245, color: "primary", icon: "📅" },
        { title: "Completed", value: 210, color: "success", icon: "✅" },
        { title: "Cancelled", value: 35, color: "danger", icon: "❌" },
    ];

    const monthlySummary = [
        { month: "January", total: 60, completed: 55, cancelled: 5 },
        { month: "February", total: 75, completed: 65, cancelled: 10 },
        { month: "March", total: 82, completed: 70, cancelled: 12 },
        { month: "April", total: 90, completed: 78, cancelled: 12 },
        { month: "May", total: 110, completed: 95, cancelled: 15 },
        { month: "June", total: 105, completed: 92, cancelled: 13 },
        { month: "July", total: 98, completed: 85, cancelled: 13 },
        { month: "August", total: 115, completed: 100, cancelled: 15 },
        { month: "September", total: 120, completed: 105, cancelled: 15 },
        { month: "October", total: 130, completed: 112, cancelled: 18 },
        { month: "November", total: 125, completed: 110, cancelled: 15 },
        { month: "December", total: 140, completed: 120, cancelled: 20 },
    ];

    return (
        <ReceptionistLayout>
            <div className="row g-4 mb-4">
                {summaryCards.map((item) => (
                    <div className="col-12 col-md-4" key={item.title}>
                        <div className={`card border-0 rounded-4 shadow-sm h-100 bg-${item.color}-subtle`}>
                            <div className="card-body d-flex flex-column justify-content-center align-items-center text-center py-8">
                                <div className={`fs-2 mb-2 text-${item.color}`}>
                                    {item.icon}
                                </div>
                                <div className="fw-semibold text-dark fs-5 mb-1">
                                    {item.title}
                                </div>
                                <div className={`fw-bolder fs-1 text-${item.color}`}>
                                    {item.value}
                                </div>

                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="card border rounded-4 shadow-sm">
                <div className="card-body p-4 p-lg-5">
                    <h3 className="fw-bold text-dark mb-5">Monthly Summary</h3>

                    <div className="table-responsive">
                        <table className="table align-middle table-row-dashed mb-0">
                            <thead>
                                <tr className="fw-bold text-dark" style={{ backgroundColor: "#dbe8fb" }}>
                                    <th className="ps-4">Month</th>
                                    <th>Total</th>
                                    <th>Completed</th>
                                    <th>Cancelled</th>
                                </tr>
                            </thead>

                            <tbody className="fw-semibold text-gray-700">
                                {monthlySummary.map((item, index) => (
                                    <tr key={index}>
                                        <td className="ps-4">{item.month}</td>
                                        <td>{item.total}</td>
                                        <td>
                                            <span className="badge badge-light-success text-success fw-bold px-3 py-2 rounded-pill">
                                                {item.completed}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="badge badge-light-danger text-danger fw-bold px-3 py-2 rounded-pill">
                                                {item.cancelled}
                                            </span>
                                        </td>
                                    </tr>
                                ))}

                                {monthlySummary.length === 0 && (
                                    <tr>
                                        <td colSpan="4" className="text-center py-10 text-muted fw-semibold">
                                            No report data found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </ReceptionistLayout>
    );
}
